// ANCHOR Payloads
import { ICpdUnitsRewardPayload } from '@lyon/utils/api/payloads/reward';

// ANCHOR Utils
import { getHighestCPD } from './getHighestCPD';

interface IProps {
  title: string;
  providerName?: string;
  contentDescription?: string;
  cpdUnitRewards?: ICpdUnitsRewardPayload[];
}

/**
 * Returns the page description of a content (course/event)
 *
 * @param title Content's title
 * @param providerName Content's provider
 * @param contentDescription Content's description
 * @param cpdUnitsRewards Array of CPD Unit Rewards
 */
export function getContentPageDescription({
  title,
  providerName,
  contentDescription = '',
  cpdUnitRewards,
}: IProps) {
  const highestCpdUnit = getHighestCPD(cpdUnitRewards);

  const cpdDescription = cpdUnitRewards?.length
    ? `Get ${(highestCpdUnit && highestCpdUnit > 0) ? `${highestCpdUnit} ` : ''}CPD points at Lyon!`
    : 'Available on Lyon!';

  if (providerName) {
    return `${cpdDescription} Learn about ${title} from ${providerName} while at home. ${contentDescription}`;
  }

  return `${cpdDescription} Learn about ${title} while at home. ${contentDescription}`;
}
